import React from 'react'
import Layout from '../components/layout'
import {browserHistory} from 'react-router'
import RaisedButton from 'material-ui/RaisedButton';
import PageviewGA from '../components/pageview-ga'

class Body extends React.Component {

    render() {
        return(
            <div className="timeout layout-row layout-align-center-start">
                <div className="page-margin">
                    <h1>Your session has timed out</h1>
                    <RaisedButton fullWidth={true} label="CONTINUE" primary={true} onClick={() => browserHistory.goBack()}/>
                </div>
            </div>
        )
    }
}


export default class extends React.Component {
    render() {
        return (
            <div className="layout-row flex">
                <PageviewGA/>
                <Layout title=""
                        showAppBarActions={false}
                        {...this.props}
                        ready={true}
                        body={Body}>
                </Layout>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/timed_out.js